export default {
  "b2b.doplnkove-sluzby-grid.title": "Supplementary services",
  "b2b.doplnkove-sluzby-grid.add": "Add service"
};
